import React, { useState, useEffect } from 'react';
import AuthPage from './pages/authpage';
import { User } from 'firebase/auth';
import { Routes, Route } from 'react-router-dom';
import MainPage from './pages/main';
import SubjectPage from './pages/subjectpage';
import NotFoundPage from './pages/404';
import MenuPage from './pages/menu';
import { AuthProvider } from "./contexts/AuthContext"
import Admin from './pages/admin';
import TeamPage from './pages/team';
import PencilSpinner from './components/PencilSpinner';
import { addAppUserOnLogin } from './serverlib/db';
import { AppUser } from './serverlib/util-types';
import "@fontsource/poppins";
import './styles/mainpage-styles.css';

interface AppProps {
    user: User | null;
    authResolved: boolean;
}

function App({ user, authResolved }: AppProps) {
    localStorage.setItem("deviceLanguage", navigator.language.split("-")[0]);
    const [appUser, setAppUser] = useState<AppUser | null>(null);

    useEffect(() => {
        if (!user) return;
        addAppUserOnLogin(
            user.uid,
            user.providerData[0]?.displayName ?? '',
            user.providerData[0]?.email ?? '',
            "student"
        ).then((au) => {
            if (au && typeof au !== 'string') setAppUser(au as AppUser);
        });
    }, [user]);

    // Show spinner only until Firebase tells us whether someone is logged in
    if (!authResolved) return <PencilSpinner />;

    if (!user) return <AuthProvider><AuthPage user={user} /></AuthProvider>;

    return (
        <AuthProvider>
            <Routes>
                <Route path='/*' element={<NotFoundPage />} />
                <Route path='/' element={<MainPage user={user} />} />
                <Route path='/menu' element={<MenuPage user={user} />} />
                <Route path='/admin' element={<Admin user={user} subjectfromurl={null} gradefromurl={null} actualgradefromurlforsubject={null} defaultTopicFromTextMatTopic={null} />} />
                <Route path='/subjectpage/*' element={<SubjectPage user={user} appUser={appUser} />} />
                <Route path='/team' element={<TeamPage user={user} />} />
            </Routes>
        </AuthProvider>
    );
}

export default App;
